// Centralized number/date formatting for the whole app.
// All date-time values are rendered in America/Mexico_City (UTC-6) regardless
// of the user's browser timezone, so the system always shows CDMX time.

const MX_TZ = "America/Mexico_City";

export const money = (n) =>
  (n ?? 0).toLocaleString("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const number = (n) => (n ?? 0).toLocaleString("es-MX");

// Returns true when input is a pure YYYY-MM-DD date string (no time component).
const isDateOnly = (s) => typeof s === "string" && /^\d{4}-\d{2}-\d{2}$/.test(s.trim());

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    // Pure date strings (e.g. hire_date "2025-01-01") must NOT be shifted by a
    // timezone — render them as-is. For full ISO datetimes, render in CDMX.
    if (isDateOnly(iso)) {
      const [y, m, d] = iso.split("-").map(Number);
      return new Date(y, m - 1, d).toLocaleDateString("es-MX", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    }
    return new Date(iso).toLocaleDateString("es-MX", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      timeZone: MX_TZ,
    });
  } catch {
    return iso;
  }
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("es-MX", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: MX_TZ,
    });
  } catch {
    return iso;
  }
};
